import React from "react";
import { HOME_PAGE } from "../..";
import { IAboutComposition } from "../../interfaces/IAbout";
import { ImageBox } from "../utils";
import {
  Image,
  Section,
  Photo,
  Content,
  Desc,
  SubHeader,
  Skills,
  SkillItem,
} from "./styles/About";

const About: React.FC & IAboutComposition = ({ children, ...restProps }) => (
  <Section {...restProps}>{children}</Section>
);

About.Image = function AboutImage({ ...restProps }) {
  return (
    <Image {...restProps}>
      <ImageBox>
        <Photo src={`${HOME_PAGE}/img/about-img.jpg`} alt='image-about' />
      </ImageBox>
    </Image>
  );
};

About.Content = function AboutContent({ children, ...restProps }) {
  return <Content {...restProps}>{children}</Content>;
};

About.Desc = function AboutDesc({ children, ...restProps }) {
  return <Desc {...restProps}>{children}</Desc>;
};

About.SubHeader = function AboutSubHeader({ children, ...restProps }) {
  return <SubHeader {...restProps}>{children}</SubHeader>;
};

About.Skills = function AboutSkills({ children, ...restProps }) {
  return <Skills {...restProps}>{children}</Skills>;
};

About.SkillItem = function AboutSkillItem({ main, children, ...restProps }) {
  return (
    <SkillItem main={main} {...restProps}>
      {children}
    </SkillItem>
  );
};

export default About;
